/**
 * SuperAdmin Forensic Audit Explorer — /superadmin/audit
 *
 * Route shell. The screen component itself (the 700-line v2 audit
 * explorer with timeline, hash-chain graph, event drawer, etc.) lives
 * in `./audit-screen.tsx` and is dynamic-imported via lazyRouteComponent.
 * This keeps the heaviest /superadmin/* surface out of the initial
 * bundle — the chunk only downloads when an operator actually reaches
 * `/superadmin/audit`.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/superadmin/audit')({
  component: lazyRouteComponent(() => import('./audit-screen'), 'AuditExplorer'),
});
